function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24.001 24.002"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.791 9.28l1.604-1.608 1.622 1.616m1.693 1.638l1.65 1.534-1.673 1.657m-4.773 1.669l1.57 1.475 1.623-1.685m-4.843-4.844L7.62 12.437l1.68 1.537M7.58 22.837l-4.787-1.864-1.382-4.835m-.338-7.996L2.89 3.166l5.659-1.965m8.014.079l4.323 1.756 1.706 4.743m-7.096 14.794l5.72-1.783 1.46-4.926"
})));